import { render, staticRenderFns } from "./SourceClassFormModal.vue?vue&type=template&id=84248bda&scoped=true"
import script from "./SourceClassFormModal.vue?vue&type=script&lang=js"
export * from "./SourceClassFormModal.vue?vue&type=script&lang=js"
import style0 from "./SourceClassFormModal.vue?vue&type=style&index=0&id=84248bda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84248bda",
  null
  
)

export default component.exports